<template>
  <div class="ma-4">
    <ClientNav />
    <signature-pad
      :showSignaturePad="showStaffSignaturePad"
      @close="showStaffSignaturePad = false"
      @signatureData="staffSignatureData"
    />

    <signature-pad
      :showSignaturePad="showClientSignaturePad"
      @close="showClientSignaturePad = false"
      @signatureData="clientSignatureData"
    />

    <v-card>
      <v-card-title style="background-color: #2b3990">
        <span class="headline white--text">{{ title }} </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="3">
              <DatePicker
                :default-date="startDate"
                v-model="startDate"
                label="Expiration Date"
              />
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <DatePicker
                :default-date="endDate"
                v-model="endDate"
                label="Expiration Date"
              />
            </v-col>

            <v-col class="d-flex" cols="12" sm="12">
              <v-text-field
                v-model="receiving"
                label="Name of Person Receiving Medications"
              ></v-text-field>
            </v-col>
            <v-col class="d-flex" cols="12" sm="12">
              <v-select
                v-model="relation"
                label="Relation to Client"
                :items="relationships"
              ></v-select>
            </v-col>

            <!-- Outgoing medications -->

            <!-- class="white--text green darken-4 text-center pa-3" -->

            <v-col cols="12" sm="12" md="12" class="pa-2 mt-4">
              <v-card class="mx-auto">
                <div
                  height="100"
                  class="white--text darken-4 text-center pa-3"
                  :class="incoming ? 'green' : 'indigo'"
                >
                  <span class="text-h5">
                    {{
                      incoming
                        ? " Client Medications IN"
                        : "Client Medications OUT"
                    }}
                  </span>

                  <v-card-subtitle class="white--text mt-n2">
                    {{
                      incoming
                        ? " Select All Medications that are being received back"
                        : " Select All Medications that are going with the client"
                    }}
                  </v-card-subtitle>
                </div>

                <v-divider></v-divider>

                <div v-if="$store.state.medhandoff.isLoading">
                  <skeleton-loader
                    loaderType="list-item-three-line"
                    v-for="i in 4"
                    :key="i"
                  />
                </div>
                <div v-else>
                  <v-tabs v-model="tab" centered flat class="mt-n2" grow>
                    <v-tabs-slider color="yellow"></v-tabs-slider>
                    <v-tab v-for="item in items" :key="item">
                      {{ item }}
                    </v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-tab-item v-for="(item, i) in items" :key="item">
                      <v-virtual-scroll
                        v-if="i === 0"
                        :items="
                          medications.filter(
                            (item) => item.medhandOffAmount != 0
                          )
                        "
                        :item-height="110"
                        height="550"
                      >
                        <template v-slot:default="{ item }">
                          <v-list flat subheader three-line>
                            <v-list-item-group
                              multiple
                              v-model="medicationList"
                            >
                              <v-list-item
                                :ripple="false"
                                :value="item"
                                @click="item.OutgoingAmount = ''"
                              >
                                <template v-slot:default="{ active }">
                                  <v-list-item-action>
                                    <v-checkbox
                                      v-model="item.outCheck"
                                      :input-value="active"
                                      @change="item.OutgoingAmount = ''"
                                    ></v-checkbox>
                                  </v-list-item-action>

                                  <v-list-item-content
                                    @click="$event.stopPropagation()"
                                  >
                                    <v-list-item-title>{{
                                      item.Medication
                                    }}</v-list-item-title>
                                    <!-- Qty Available:
                                      {{
                                        incoming
                                        ? item.medhandOffAmount
                                        : item.MedInventory.Quantity
                                      }} -->

                                    <v-col cols="12" class="pa-0 ma-0">
                                      <v-text-field
                                        :disabled="!item.outCheck"
                                        label="Outgoing Amount"
                                        width="10"
                                        v-model="item.OutgoingAmount"
                                        @click="$event.stopPropagation()"
                                      ></v-text-field>
                                    </v-col>
                                    <v-divider></v-divider>
                                  </v-list-item-content>
                                </template>
                              </v-list-item>
                            </v-list-item-group>
                          </v-list>
                        </template>
                      </v-virtual-scroll>
                      <div v-else>
                        <v-data-table
                          :headers="headers"
                          :items="history"
                          sort-by="date"
                          sort-desc
                          height="550"
                        >
                          <template v-slot:item.type="{ item }">
                            <v-chip
                              small
                              :color="
                                item.type === 'incoming' ? 'green' : 'indigo'
                              "
                              dark
                            >
                              <span class="text-caption">{{ item.type }}</span>
                            </v-chip>
                          </template>
                        </v-data-table>
                      </div>
                    </v-tab-item>
                  </v-tabs-items>
                </div>

                <v-divider></v-divider>

                <v-row class="pa-3" v-if="!incoming">
                  <v-col cols="12" sm="12" md="6">
                    <DatePicker
                      :default-date="handoffDate"
                      v-model="handoffDate"
                      label="Expiration Date"
                    />
                  </v-col>

                  <v-col cols="12" sm="12" md="6">
                    <v-menu
                      ref="menu"
                      v-model="handoffTimeMenu"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      :return-value.sync="handoffTime"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="handoffTime"
                          label="Hand Off time"
                          prepend-icon="mdi-clock-time-four-outline"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-time-picker
                        v-if="handoffTimeMenu"
                        v-model="handoffTime"
                        full-width
                        @click:minute="$refs.menu.save(handoffTime)"
                      ></v-time-picker>
                    </v-menu>
                  </v-col>
                </v-row>

                <v-row v-if="!incoming">
                  <v-col cols="12" sm="12" md="6">
                    <div class="mx-2">
                      <v-card class="mx-auto pa-5">
                        <skeleton-loader
                          loaderType="image"
                          v-if="$store.state.medhandoff.isLoading"
                        />
                        <div v-else>
                          <v-img
                            :src="clientSignature"
                            height="200"
                            contain
                          ></v-img>
                          <v-btn
                           :small="$vuetify.breakpoint.smAndDown"
                            block
                            class="white--text ma-1"
                            color="#2b3990"
                            @click.stop="showClientSignaturePad = true"
                            >Med Recipient Signature</v-btn
                          >
                        </div>
                      </v-card>
                    </div>
                  </v-col>

                  <v-col cols="12" sm="12" md="6">
                    <div class="mx-2">
                      <v-card class="mx-auto pa-5">
                        <skeleton-loader
                          loaderType="image"
                          v-if="$store.state.medhandoff.isLoading"
                        />
                        <div v-else>
                          <v-img
                            :src="staffSignature"
                            height="200"
                            contain
                          ></v-img>
                          <v-btn
                            :small="$vuetify.breakpoint.smAndDown"
                            block
                            class="white--text ma-1"
                            color="#2b3990"
                            @click.stop="showStaffSignaturePad = true"
                            >Staff Medhand Off Signature</v-btn
                          >
                        </div>
                      </v-card>
                    </div>
                  </v-col>
                </v-row>

                <v-row class="pa-3" v-if="!incoming">
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      readonly
                      label="Prepared By"
                      v-model="enteredBy"
                      @click="enteredBySignature"
                      :disabled="incoming"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      readonly
                      label="Verified By"
                      v-model="verifiedBy"
                      @click="verifiedBySignature"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <!-- End of Outgoing medications -->
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="!isAuditorRole"
          class="white--text"
          :color="$route.params.action === 'edit' ? 'blue darken-1' : '#259647'"
          @click="
            $route.params.action === 'edit' ? onUpdateItem() : onAddItem()
          "
          >{{ $route.params.action === "edit" ? "Update " : "Save" }}</v-btn
        >
        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
/*eslint-disable */
import DatePicker from "@/components/DateTimePickers/DatePicker.vue";

const url = require("@/client_config/config").url;
import SignaturePad from "@/components/SignaturePad";
import SkeletonLoader from "@/components/shared/SkeletonLoader";
import ClientNav from "@/components/ClientNav";
import { mapActions, mapMutations, mapGetters } from "vuex";
import TimePicker from "@/components/DateTimePickers/TimePicker.vue";
import moment from "moment/moment";
import DateTimeUtil from "../../../../../utils/date-time.util";
import {displayError} from "@/service/notification-message.service";

const DATE = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
  .toISOString()
  .substr(0, 10);

export default {
  components: {TimePicker, DatePicker, SignaturePad, SkeletonLoader, ClientNav },
  props: {
    // medications: {
    //   type: Array,
    //   default: () => [],
    // },
    // medicationListItem: {
    //   type: Array,
    //   default: () => [],
    // },
    // medHandOffData: {
    //   type: Object,
    // },
    // incoming: {
    //   type: Boolean,
    // },
  },

  data() {
    return {
      headers: [
        {
          text: "Date",
          align: "start",
          sortable: false,
          value: "date",
        },
        { text: "Medication", value: "medication" },
        { text: "Outgoing Amount", value: "outgoingAmount" },
        { text: "Incoming Amount", value: "incomingAmount" },
        { text: "Total Medication Given", value: "givenMedication" },
      ],
      clientID: this.$route.params.clientID,
      staff: localStorage.getItem("Name"),
      startDateMenu: false,
      endDateMenu: false,
      handoffDateMenu: false,
      handoffTimeMenu: false,
      relationships: [
        "Guardian",
        "Father",
        "Mother",
        "Relative",
        "School",
        "Correction Facility",
        "Other",
      ],
      startDate: DATE,
      endDate: DATE,
      handoffDate: DATE,
      handoffTime: "",
      receiving: "",
      relation: "",
      outgoing: {},
      outgoingMeds: [],
      incomingMeds: [],
      titleForm: "New Med Hand Off",
      editMedHandOff: false,
      medHandOffID: null,
      outgoingDetails: null,
      incomingDetails: null,
      ongoing: null,
      medicationList: [],
      enteredBy: "",
      verifiedBy: "",
      medicationPrevVal: [],
      showClientSignaturePad: false,
      showStaffSignaturePad: false,
      staffSignature: null,
      clientSignature: null,
      items: ["Medication", "History"],
      tab: null,
      history: [],
      outgoingStaffSignature: null,
      outgoingClientSignature: null,
      incomingStaffSignature: null,
      incomingClientSignature: null,
      medicationCopy: this.medications,
      medications: [],
      medicationListItem: [],
      incoming: false,
    };
  },

  created() {
    this.fetch();
  },

  computed: {
    ...mapGetters("medhandoff", ["getMedications"]),
    title() {
      return this.$route.params.action === "add"
        ? "New Medhand Off"
        : "Update Medhand Off";
    },
    show: {
      get() {
        return this.$store.state.medhandoff.dialog;
      },
      set(val) {
        this.$store.commit("medhandoff/SET_DIALOG", val);
      },
    },
    isAuditorRole() {
        return localStorage.getItem("userRole") === 'Auditor'
    }
  },

  methods: {
    ...mapActions("medhandoff", [
      "fetchItems",
      "fetchItem",
      "fetchMedicationItem",
      "saveItem",
      "updateItem",
      "updateInventoryItem",
    ]),
    ...mapMutations({
      setSnackbar: "SET_SNACKBAR",
    }),

    initialized() {},

    close() {
      this.$router.push({
        path: `/medHandOff/${this.clientID}`,
      });
    },

    async onAddItem() {
      try {
        let medHistoryData = [];

        if(!this.outgoingStaffSignature || !this.staffSignature) {
          displayError("Please fill-up signature")
          return;
        }

        const selectedMedicationData = this.medicationList.map((item) => {
          return {
            amount: item.OutgoingAmount,
            _id: item.MedInventory._id,
            qty:
              parseInt(item.MedInventory.Quantity) -
              parseInt(item.OutgoingAmount),
            medication_id: item._id,
          };
        });

        // removing 'qty' from medication array
        const medication = selectedMedicationData.map(({ qty, ...rest }) => ({
          ...rest,
        }));

        const data = {
          startDate: this.startDate,
          endDate: this.endDate,
          receiving: this.receiving,
          relation: this.relation,
          outgoing: {
            handoffDate: this.handoffDate,
            handoffTime: this.handoffTime,
            enteredBy: this.enteredBy,
            verifiedBy: this.verifiedBy,
            staffSignature: this.outgoingStaffSignature,
            clientSignature: this.outgoingClientSignature,
            medication: medication.filter((item) => item.amount !== ""),
          },
          clientID: this.clientID,
        };

        console.log({data});

        await this.saveItem(data);
        this.close();
      } catch (error) {
        console.log(error);
      }
    },

    async onUpdateItem() {
      let medication = {};

      if(!this.outgoingStaffSignature || !this.staffSignature) {
        displayError("Please fill-up signature")
        return;
      }

      if (!this.incoming) {
        const outgoingMedication = this.medications
          .filter(
            (item) =>
              item.outCheck &&
              (item.OutgoingAmount !== "" || item.OutgoingAmount !== 0)
          )
          .map((item) => ({
            amount: item.OutgoingAmount,
            _id: item.MedInventory._id,
            medication_id: item._id,
          }));

        medication = {
          startDate: this.startDate,
          endDate: this.endDate,
          receiving: this.receiving,
          relation: this.relation,
          clientID: this.clientID,
          outgoing: {
            handoffDate: this.handoffDate,
            handoffTime: this.handoffTime,
            enteredBy: this.enteredBy,
            verifiedBy: this.verifiedBy,
            staffSignature: this.outgoingStaffSignature,
            clientSignature: this.outgoingClientSignature,
            medication: outgoingMedication,
          },
        };
      }

      if (this.incoming) {
        const incomingMedication = this.medications.map((item) => ({
          amount: item.OutgoingAmount,
          _id: item.MedInventory._id,
          medication_id: item._id,
        }));

        medication = {
          incoming: incomingMedication,
        };
      }

      try {
        await this.updateItem({
          medication,
          id: this.medHandOffID,
          type: !this.incoming ? "outgoing" : "incoming",
        });
        this.close();
      } catch (error) {
        console.log(error);
      }
    },

    async viewItem(item) {
      this.medHandOffID = item._id;
      this.history = item.history;

      //update
      this.editMedHandOff = item.editMedHandOff;
      this.titleForm = item.titleForm;

      this.startDate = DateTimeUtil.toLocalDate(item.startDate);
      this.endDate = DateTimeUtil.toLocalDate(item.endDate);
      this.receiving = item.receiving;
      this.relation = item.relation;
      this.handoffDate = DateTimeUtil.toLocalDate(item.handoffDate);
      this.handoffTime = item.outgoing.handoffTime;
      this.verifiedBy = item.outgoing.verifiedBy;
      this.staffSignature = item.outgoing.staffSignature;
      this.clientSignature = item.outgoing.clientSignature;

      this.outgoingStaffSignature = item.outgoing.staffSignature;
      this.outgoingClientSignature = item.outgoing.clientSignature;

      if (item.outgoing.enteredBy !== "") {
        this.enteredBy = item.outgoing.enteredBy;
        if(this.enteredBy.includes("Z")){
          this.enteredBy = this.formatSignature(this.enteredBy);
        }
      }

      if (item.outgoing.verifiedBy !== "") {
        this.verifiedBy = item.outgoing.verifiedBy;
        if(this.verifiedBy.includes("Z")){
          this.verifiedBy = this.formatSignature(this.verifiedBy);
        }
      }
    },

    async fetch() {
      try {
        await this.fetchMedicationItem(this.clientID);

        if (!this.$route.query.id) {
          this.medications = await this.getMedications;
          return;
        }

        this.incoming = JSON.parse(this.$route.query.incoming);

        await this.fetchItems(this.clientID);
        const item = await this.fetchItem(this.$route.query.id);

        const data = item?.outgoing?.medication || [];

        const result = this.getMedications.map((meditem) => {
          const medication = data.find(
            (outItem) => outItem._id === meditem.MedInventory._id
          );
          const amount = medication?.amount || 0;

          return {
            ...meditem,
            outCheck: !!amount,
            OutgoingAmount: amount,
          };
        });

        // Assign Outgoing Amount -> medhandOffAmount
        const medicationItem = result.map((item) => ({
          ...item,
          medhandOffAmount: item.OutgoingAmount,
        }));

        // Filter incoming medication based on medhandOffAmount
        this.medications = this.incoming
          ? medicationItem.filter((item) => item.medhandOffAmount !== undefined)
          : medicationItem;

        await this.viewItem(item);
      } catch (error) {
        console.error(error);
      }
    },

    enteredBySignature() {
      this.enteredBy = this.staff + " - " + moment().utc().toISOString();
    },

    verifiedBySignature() {
      this.verifiedBy = this.staff + " - " + moment().utc().toISOString();
    },

    staffSignatureData(data) {
      if (this.incoming) {
        this.incomingStaffSignature = data;
      } else {
        this.outgoingStaffSignature = data;
      }
      this.staffSignature = data;
    },

    clientSignatureData(data) {
      if (this.incoming) {
        this.incomingClientSignature = data;
      } else {
        this.outgoingClientSignature = data;
      }
      this.clientSignature = data;
    },

    clear() {
      this.startDate = DATE;
      this.endDate = DATE;
      this.receiving = "";
      this.relation = "";
      this.handoffDate = DATE;
      this.handoffTime = "";
      this.enteredBy = "";
      this.verifiedBy = "";
      this.medicationList = [];
      (this.incomingStaffSignature = ""), (this.outgoingStaffSignature = "");
      this.incomingClientSignature = "";
      this.outgoingClientSignature = "";
      this.staffSignature = "";
      this.clientSignature = "";
      this.editMedHandOff = false;
      this.tab = null;
    },

    formatSignature(enteredBy) {
      if (!enteredBy || enteredBy === "") {
        return "";
      }

      if (enteredBy.includes("Z")) {
        const [name, utcTime] = enteredBy.split(" - ");
        const cleanUtcTime = utcTime.replace("Z", ""); // Remove "Z" for parsing
        const localTime = moment.utc(cleanUtcTime, "YYYY-MM-DD HH:mm").local().format("YYYY-MM-DD HH:mm");
        return `${name} - ${localTime}`;
      }

      return enteredBy;
    },

  },
  watch: {
    medicationListItem(val) {
      let medicationHistory = this.history
        .filter((historyItem) => historyItem !== null)
        .map((historyItem) => {
          const med = val.find(
            (med) => med.MedInventory._id === historyItem._id
          );
          if (med) {
            return {
              ...historyItem,
              medication: med.Medication,
            };
          }
        });
      this.history = medicationHistory;
    },
  },
};
</script>
